<ng-container *transloco="let t">
  <div class="mb-2 d-flex flex-column pt-3">
    <p class="medium">
      <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng"
                           [itLabel]="race?.nameIta"
                           [siLabel]="race?.nameSlo"
                           [srLabel]="race?.nameSr"
                           [bsLabel]="race?.nameBs"
                           [defaultLanguage]="defaultLanguage" [languages]="languages"/>
    </p>

    <p class="regular">
      {{
        (race?.registrationType === RegistrationType.RACE && race?.length && (race?.length ?? 0) > 0) ?
          (race?.length | raceLengthFormat:translocoService.getActiveLang())
          : ''
      }}
    </p>

    @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
      <p class="medium pt-3 text-uppercase">
        {{ t('app.common.price') }}
      </p>
      <ng-template [ngTemplateOutlet]="competitorSummaryPrice"/>

    } @else {
      <p class="medium pt-3  text-uppercase">
        {{ t('app.common.price') }}
      </p>
      @if(raceCommercialItems.length === 1) {
        <ng-template [ngTemplateOutlet]="raceCommercialItemPrice"/>
      }
      @else{
        <ng-template [ngTemplateOutlet]="competitorSummaryPrice"/>
      }

    }
    <ng-template #raceCommercialItemPrice>
        @if (raceCommercialItems[0]?.price !== undefined){
            <p class="regular">
                <span class="fw-medium">
                <app-language-output [hrLabel]="raceCommercialItems[0]?.name"
                            [enLabel]="raceCommercialItems[0]?.nameEng"
                            [itLabel]="raceCommercialItems[0]?.nameIta"
                            [siLabel]="raceCommercialItems[0]?.nameSlo"
                            [srLabel]="raceCommercialItems[0]?.nameSr"
                            [bsLabel]="raceCommercialItems[0]?.nameBs"
                            [defaultLanguage]="defaultLanguage" [languages]="languages"/>
                </span>
            -
            {{
                getRaceCommercialItemPrice(raceCommercialItems[0])
                }}
            </p>
        }
    </ng-template>

    <ng-template #competitorSummaryPrice>
        @if(competitorRegistrationSummaryItem?.raceCommercialItem?.price !== undefined) {
            <p class="regular">
             <span class="fw-medium">
                <app-language-output [hrLabel]="competitorRegistrationSummaryItem?.raceCommercialItem?.name"
                      [enLabel]="competitorRegistrationSummaryItem?.raceCommercialItem?.nameEng"
                      [itLabel]="competitorRegistrationSummaryItem?.raceCommercialItem?.nameIta"
                      [siLabel]="competitorRegistrationSummaryItem?.raceCommercialItem?.nameSlo"
                      [srLabel]="competitorRegistrationSummaryItem?.raceCommercialItem?.nameSr"
                      [bsLabel]="competitorRegistrationSummaryItem?.raceCommercialItem?.nameBs"
                      [defaultLanguage]="defaultLanguage" [languages]="languages"/>
             </span>
            -
            {{
                getRaceCommercialItemPrice(competitorRegistrationSummaryItem?.raceCommercialItem)
            }}
            </p>
        }
    </ng-template>
  </div>
</ng-container>
